import type { AnyAction } from 'redux';
import { AVAILABLE_CARBON_LAYERS } from '../../screens/Map/components/Overlays/MapControlsOverlay/MapControls/ CarbonLayerSelect/constants';
import actions from './actions';
import type { MapState, SingleMapState } from './models';

const getNewMap = (selected_index): SingleMapState => ({
  viewMode: 'map',
  variability: 1.0,
  variabilityPalette: [],
  prescriptionPalette: [],
  prescriptionPaletteName: null,
  selected_index,
  selectedCarbonLayer: AVAILABLE_CARBON_LAYERS[0],
  trialingPlotsEnabled: false,
  anomalyDetectionEnabled: false,
});

const initialState: MapState = {
  mode: 'idle',
  labelsVisible: true,
  roadNamesVisible: false,
  zoom: 15,
  mapStyle: undefined,
  map: getNewMap(null),
  sideMap: getNewMap('ndvi'),
  sideMapEnabled: false,
  showVariabilityHint: true,
  hoveredFieldId: undefined,
  fieldSnapshotVisible: false,
  fieldSnapshotSettingsVisible: false,
  showVisualLayer: true,
};

const reducer = (state = initialState, action: AnyAction): MapState => {
  switch (action.type) {
    case actions.SET_MAP_MODE:
      return {
        ...state,
        mode: action.payload,
      };
    case actions.SET_LABEL_VISIBILITY:
      return {
        ...state,
        labelsVisible: action.payload,
      };
    case actions.SET_ROAD_NAMES_VISIBILITY:
      return {
        ...state,
        roadNamesVisible: action.payload,
      };
    case actions.SET_MAP_ZOOM:
      return {
        ...state,
        zoom: action.payload,
      };
    case actions.SET_MAP_PALETTE_VARIABILITY:
      return {
        ...state,
        [action.map]: {
          ...state[action.map],
          variabilityPalette: action.payload,
        },
      };
    case actions.SET_MAP_PALETTE_PRESCRIPTIONS:
      return {
        ...state,
        [action.map]: {
          ...state[action.map],
          prescriptionPalette: action.payload.palette,
          prescriptionPaletteName: action.payload.paletteName,
        },
      };
    case actions.SET_FIELD_VARIABILITY:
      return {
        ...state,
        [action.map]: {
          ...state[action.map],
          variability: action.payload,
        },
      };
    case actions.SET_MAP_VIEW_MODE:
      return {
        ...state,
        [action.map]: {
          ...state[action.map],
          viewMode: action.payload,
        },
      };
    case actions.SET_MAP_STYLE:
      return {
        ...state,
        mapStyle: action.payload,
      };
    case actions.SET_SIDE_MAP_INDEX:
      return {
        ...state,
        sideMap: {
          ...state.sideMap,
          selected_index: action.payload,
        },
      };
    case actions.SET_SIDE_MAP_ENABLED:
      return {
        ...state,
        sideMapEnabled: action.payload,
      };
    case actions.SET_HOVERED_FIELD_ID:
      return {
        ...state,
        hoveredFieldId: action.payload,
      };
    case actions.SET_VARIABILITY_HINT:
      return {
        ...state,
        showVariabilityHint: action.payload,
      };
    case actions.SET_MAPVIEW_SNAPSHOT_VISIBILITY:
      return {
        ...state,
        fieldSnapshotVisible: action.payload,
      };
    case actions.SET_MAPVIEW_SNAPSHOT_SETTINGS_VISIBILITY:
      return {
        ...state,
        fieldSnapshotSettingsVisible: action.payload,
      };
    case actions.SET_MAP_SELECTED_CARBON_LAYER:
      return {
        ...state,
        [action.map]: {
          ...state[action.map],
          selectedCarbonLayer: action.payload,
        },
      };
    case actions.SET_VISUAL_LAYER_VISIBILITY:
      return {
        ...state,
        showVisualLayer: action.payload,
      };
    case actions.SET_MAP_ANOMALY_DETECTION:
      return {
        ...state,
        [action.map]: {
          ...state[action.map],
          anomalyDetectionEnabled: action.payload,
        },
      };
    case actions.SET_TRIALING_PLOTS:
      return {
        ...state,
        [action.map]: {
          ...state[action.map],
          trialingPlotsEnabled: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
